import React, { HTMLAttributes, ElementType } from "react";
import {
    ClickWithKeyboardEventInteraction,
    useInteraction,
} from "@hooks/useInteraction";

interface ClickableContainerProps extends HTMLAttributes<HTMLDivElement> {
    onClick: (e: any) => void;
    as?: ElementType;
}

export const ClickableContainer: React.FC<ClickableContainerProps> = ({
    children,
    onClick,
    as: Component = "div",
    ...rest
}) => {
    const clickInteraction = useInteraction(
        onClick,
    ) as ClickWithKeyboardEventInteraction<() => void>;

    return (
        <Component {...clickInteraction} {...rest}>
            {children}
        </Component>
    );
};
